import {
  FETCH_BEST_BACK_PRIZE,
  FETCH_BEST_BACK_OBJECT,
  FETCH_BEST_BACK_USER_STATUS,
  FETCH_NBL_COMPETITION_PRIZE,
  FETCH_NBL_COMPETITION_OBJECT,
  FETCH_NBL_COMPETITION_USER_STATUS,
  FETCH_UK_COMPETITION_PRIZE,
  FETCH_UK_COMPETITION_OBJECT,
  FETCH_UK_COMPETITION_USER_STATUS,
  FETCH_AU_COMPETITION_PRIZE,
  FETCH_AU_COMPETITION_OBJECT,
  FETCH_AU_COMPETITION_USER_STATUS,
  FETCH_INTL_COMPETITION_PRIZE,
  FETCH_INTL_COMPETITION_OBJECT,
  FETCH_INTL_COMPETITION_USER_STATUS,
  FETCH_PROMO_DISPLAY_CONFIGS,
  REMOVE_PROMO_DISPLAY_CONFIG,
  FETCH_PLACE_SITELINKS,
  CHECK_PROMO_DISPLAY_CONFIG,
  FETCH_METASEARCH_DISCOUNT,
} from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import {
  API_CALL_REQUEST,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
  CHECKOUT_FETCHING_VOUCHERS,
  FETCH_ALL_VOUCHERS,
  FETCH_CHANNEL_MARKUP,
  FETCH_META_OFFERS_DISCOUNT,
  SET_METASEARCH_PROPERTY_BLACKLIST,
  SET_BYPASS_REGION_EXCLUSION_OFFER_IDS,
  SET_BYPASS_REGION_SETTING_ID,
} from 'actions/actionConstants'

export const initialMarketingState: App.MarketingState = {
  competition: null,
  fetching: false,
  sitelinks: {},
  metaOffersDiscount: {},
  metasearchDiscount: {
    fetching: false,
    requestKey: undefined,
    discountAmount: undefined,
  },
  metasearchPropertyBlacklist: {},
  vouchers: [],
  allVouchers: [],
  allVouchersStatus: undefined as App.VoucherStatus | undefined,
  isFetchingAllVouchers: false,
  bypassRegionExclusionOfferIds: [],
  bypassRegionSettingId: undefined,
}

// TODO: MAPPER FUNCTION FOR REDUCER
const apiCalls = apiReducerSwitch<App.MarketingState>({
  [FETCH_BEST_BACK_PRIZE]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, prize: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, prize: null },
    }),
  },
  [FETCH_BEST_BACK_OBJECT]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, object: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, object: null },
    }),
  },
  [FETCH_BEST_BACK_USER_STATUS]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, status: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, status: null },
    }),
  },
  [FETCH_NBL_COMPETITION_PRIZE]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, prize: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, prize: null },
    }),
  },
  [FETCH_NBL_COMPETITION_OBJECT]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, object: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, object: null },
    }),
  },
  [FETCH_NBL_COMPETITION_USER_STATUS]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, status: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, status: null },
    }),
  },
  [FETCH_UK_COMPETITION_PRIZE]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, prize: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, prize: null },
    }),
  },
  [FETCH_UK_COMPETITION_OBJECT]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, object: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, object: null },
    }),
  },
  [FETCH_UK_COMPETITION_USER_STATUS]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, status: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, status: null },
    }),
  },
  [FETCH_AU_COMPETITION_PRIZE]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, prize: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, prize: null },
    }),
  },
  [FETCH_AU_COMPETITION_OBJECT]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, object: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, object: null },
    }),
  },
  [FETCH_AU_COMPETITION_USER_STATUS]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, status: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, status: null },
    }),
  },
  [FETCH_INTL_COMPETITION_PRIZE]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, prize: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, prize: null },
    }),
  },
  [FETCH_INTL_COMPETITION_OBJECT]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, object: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, object: null },
    }),
  },
  [FETCH_INTL_COMPETITION_USER_STATUS]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      competition: { ...state.competition, status: action.data },
    }),
    failure: (state) => ({
      fetching: false,
      competition: { ...state.competition, status: null },
    }),
  },
  [FETCH_CHANNEL_MARKUP]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      channelMarkup: action.data,
    }),
    failure: () => ({
      fetching: false,
      channelMarkup: undefined,
    }),
  },
  [FETCH_PROMO_DISPLAY_CONFIGS]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      promoDisplayConfigs: action.data,
    }),
    failure: () => ({
      fetching: false,
      promoDisplayConfigs: undefined,
    }),
  },
  [FETCH_PLACE_SITELINKS]: {
    request: (state, action) => ({
      sitelinks: {
        ...state.sitelinks,
        [action.placeName]: {
          fetching: true,
        },
      },
    }),
    success: (state, action) => {
      return {
        sitelinks: {
          ...state.sitelinks,
          [action.placeName]: {
            fetching: false,
            data: action.data,
          },
        },
      }
    },
    failure: (state, action) => ({
      sitelinks: {
        ...state.sitelinks,
        [action.placeName]: {
          fetching: false,
          error: action.error,
        },
      },
    }),
  },
  [CHECKOUT_FETCHING_VOUCHERS]: {
    success: (_state, action) => ({
      vouchers: action.data,
    }),
  },
  [FETCH_ALL_VOUCHERS]: {
    request: (_state, action) => ({
      isFetchingAllVouchers: true,
      allVouchersStatus: action.status,
    }),
    success: (_state, action) => ({
      allVouchers: action.data,
      isFetchingAllVouchers: false,
    }),
    failure: () => ({
      isFetchingAllVouchers: false,
    }),
  },
  [CHECK_PROMO_DISPLAY_CONFIG]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => {
      if (state.promoDisplayConfigs) {
        const promoDisplayConfig = state.promoDisplayConfigs[action.data.promoDisplayId]
        const newFields: App.PromoDisplayConfigResult = {
          checkPassed: action.data.checkPassed,
          displayOptionKey: action.data.displayOptionKey as string,
          eventsFired: action.data.eventsFired,
          path: action.data.path,
          codeName: action.data.codeName ?? promoDisplayConfig.codeName,
          expiresAt: state.promoDisplayConfigs[action.data.promoDisplayId].expiresAt as string,
          headerText: action.data.headerTextOverride ?? promoDisplayConfig.headerText,
          bodyText: action.data.bodyTextOverride ?? promoDisplayConfig.bodyText,
          resultCode: action.data.resultCode,
          promoDisplayConfigId: action.data.promoDisplayId,
        }
        const updatedPassOfferCheck: App.PromoDisplayConfig['passOfferCheck'] = { ...state.promoDisplayConfigs[action.data.promoDisplayId].passOfferCheck, [action.data.path]: newFields }
        const updatedPromoDisplayConfig: App.PromoDisplayConfigMap[string] = {
          ...state.promoDisplayConfigs[action.data.promoDisplayId],
          passOfferCheck: updatedPassOfferCheck,
          codeName: action.data.codeName as string,
          displayOptionKey: action.data.displayOptionKey as string,
          expiresAt: state.promoDisplayConfigs[action.data.promoDisplayId].expiresAt as string,
          headerText: action.data.headerTextOverride ?? promoDisplayConfig.headerText,
          bodyText: action.data.bodyTextOverride ?? promoDisplayConfig.bodyText,
        }

        return {
          fetching: false,
          promoDisplayConfigs: { ...state.promoDisplayConfigs, [action.data.promoDisplayId]: updatedPromoDisplayConfig },
        }
      }
      return state
    },
    failure: () => ({
      fetching: false,
    }),
  },
  [REMOVE_PROMO_DISPLAY_CONFIG]: {
    success: (state, action) => {
      if (state.promoDisplayConfigs) {
        const { [action.data.promoDisplayId]: _, ...newConfigs } = state.promoDisplayConfigs
        return {
          promoDisplayConfigs: newConfigs,
        }
      }
      return state
    },
  },
  [FETCH_META_OFFERS_DISCOUNT]: {
    request: () => ({
      fetching: true,
      metaOffersDiscount: {},
    }),
    success: (state, action) => ({
      fetching: false,
      metaOffersDiscount: { [action.data.offerId]: { fetching: false, packages: action.data.packages } },
    }),
    failure: (state, _action) => ({
      fetching: false,
      metaOffersDiscount: { ...state.metaOffersDiscount },
    }),
  },
  [FETCH_METASEARCH_DISCOUNT]: {
    request: (_state, action) => ({
      metasearchDiscount: {
        fetching: true,
        requestKey: action.requestKey,
        error: undefined,
        discountAmount: undefined,
      },
    }),
    success: (state, action) => {
      if (state.metasearchDiscount.requestKey && state.metasearchDiscount.requestKey !== action.requestKey) {
        return undefined
      }

      return {
        metasearchDiscount: {
          fetching: false,
          requestKey: action.requestKey,
          discountAmount: action.data?.discountAmount ?? 0,
        },
      }
    },
    failure: (state, action) => {
      if (state.metasearchDiscount.requestKey && state.metasearchDiscount.requestKey !== action.requestKey) {
        return undefined
      }

      return {
        metasearchDiscount: {
          fetching: false,
          requestKey: action.requestKey,
          error: action.error,
          discountAmount: 0,
        },
      }
    },
  },
})

export default createAppReducer<App.MarketingState>(initialMarketingState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [SET_METASEARCH_PROPERTY_BLACKLIST]: (_state, action) => ({
    metasearchPropertyBlacklist: action.blacklist,
  }),
  [SET_BYPASS_REGION_EXCLUSION_OFFER_IDS]: (_state, action) => ({
    bypassRegionExclusionOfferIds: action.offerIds,
  }),
  [SET_BYPASS_REGION_SETTING_ID]: (_state, action) => ({
    bypassRegionSettingId: action.settingId,
  }),
})
